// extracted by mini-css-extract-plugin
module.exports = {"editUserAccountContainer":"UserDetails_editUserAccountContainer__oWvk6"};